<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header justify-content-between border-0">
        <h5 class="card-title font-bold">آزمایش ها</h5>
        <div>
          <b-button
            v-b-toggle.filter-experiments
            variant="primary"
            class="ml-2"
          >
            <span class="fe fe-search pt-1" style="font-size: 17px;"></span>
          </b-button>
          <span id="add-btn">
            <b-button v-b-modal.modal-add-experiment variant="success"
              >آزمایش جدید</b-button
            >
          </span>
        </div>
      </div>
      <b-collapse id="filter-experiments" class="mt-2 mx-5">
        <b-card>
          <form @submit.prevent="doFilter">
            <div class="row mt-5">
              <b-form-group class="col-md-3">
                <b-form-input
                  type="number"
                  placeholder="سریال"
                  v-model="filter.serial"
                ></b-form-input>
              </b-form-group>
              <BFormGroup class="col-3">
                <BFormSelect v-model="filter.status" :options="statusOptions" />
              </BFormGroup>
              <b-form-group class="col-md-3">
                <CustomerSearch
                  v-model="filter.user_id"
                  :allow-empty="true"
                  :show-label="false"
                />
              </b-form-group>
              <b-form-group class="col-md-4">
                <date-picker
                  placeholder="از تاریخ"
                  v-model="filter.start_date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </b-form-group>
              <b-form-group class="col-md-4">
                <date-picker
                  placeholder="تا تاریخ"
                  v-model="filter.end_date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </b-form-group>
            </div>
            <div class="text-center mt-3">
              <button
                :disabled="disabled"
                type="submit"
                class="btn btn-primary px-5"
              >
                جستجو
              </button>
              <button
                :disabled="disabled"
                type="button"
                @click="
                  $root.$emit('bv::toggle::collapse', 'filter-experiments')
                "
                class="btn btn-secondary px-5 mr-3"
              >
                بستن
              </button>
            </div>
          </form>
        </b-card>
      </b-collapse>

      <div class="card-body">
        <div>
          <b-table hover bordered :items="items.data" :fields="fields">
            <template v-slot:cell(username)="data">
              <span>
                {{
                  data.item.user
                    ? data.item.user.first_name
                      ? data.item.user.first_name +
                        " " +
                        data.item.user.last_name
                      : data.item.user.mobile
                    : ""
                }}
              </span>
            </template>
            <template v-slot:cell(status)="data">
              <span
                v-if="data.item.status === 'canceled'"
                class="badge badge-danger status"
                >لغو شده</span
              >
              <span
                v-else-if="data.item.status === 'new'"
                class="badge badge-success status"
                >جدید</span
              >
              <span
                v-else-if="data.item.status === 'done'"
                class="badge badge-primary status"
                >انجام شده</span
              >
              <span
                v-else-if="data.item.status === 'received'"
                class="badge badge-info status"
                >دریافت شده</span
              >
            </template>
            <template v-slot:cell(result)="data">
              {{ data.item.result ? "دارد" : "ندارد" }}
            </template>
            <template v-slot:cell(receive_datetime)="data">
              {{ data.item.receive_datetime | Date }}
            </template>
            <template v-slot:cell(edit)="data">
              <span :id="'edit-btn-' + data.item.id">
                <router-link
                  :to="`/admin/experiment/${data.item.id}`"
                  class="action-btns1 pt-1 px-2"
                >
                  <i class="feather feather-edit  text-primary"></i>
                </router-link>
              </span>
            </template>
            <template v-slot:cell(delete)="data">
              <span
                class="action-btns1 pt-1 px-2 "
                @click="deleteItem(data.item.id)"
              >
                <i class="feather feather-trash-2 text-danger"></i>
              </span>
            </template>
          </b-table>
          <Loading v-if="$root.isEmptyObject(items)" />
          <pagination
            v-else-if="items.data != ''"
            :disabled="disabled"
            :limit="2"
            :data="items"
            @pagination-change-page="changePage"
          >
          </pagination>
          <div v-else class="alert alert-danger">
            موردی یافت نشد
          </div>
        </div>
      </div>
    </div>
    <b-modal
      size="md"
      :hideFooter="true"
      id="modal-add-experiment"
      title="آزمایش جدید"
    >
      <BForm @submit.prevent="submitHandler">
        <BFormGroup label="شماره سریال">
          <b-form-input type="number" v-model="createForm.serial" />
        </BFormGroup>
        <BFormGroup label="توضیحات">
          <BFormTextarea
            v-model="createForm.description"
            placeholder="توضیحات..."
            rows="3"
          />
        </BFormGroup>
        <b-form-group label="تاریخ دریافت">
          <date-picker
            type="datetime"
            v-model="createForm.receive_datetime"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD HH:mm"
            color="#3366ff"
          />
        </b-form-group>
        <BFormGroup label="کاربر">
          <CustomerSearch
            v-model="createForm.user"
            :allow-empty="true"
            :show-label="false"
          />
        </BFormGroup>
        <BFormGroup label="آدرس ها">
          <template v-if="adressess && adressess.length">
            <multiselect
              v-model="createForm.address"
              placeholder="انتخاب مشتری"
              :allow-empty="false"
              open-direction="bottom"
              :options="adressess"
              label="label"
              track-by="id"
              :searchable="true"
              :multiple="false"
              :close-on-select="true"
              :show-labels="false"
              :disabled="disabled"
            >
              <template slot="noOptions">
                جستجو کنید
              </template>
            </multiselect>
          </template>
          <template v-else>
            <p class="text-primary pr-2">
              ابتدا کاربر را انتخاب کنید
            </p>
          </template>
        </BFormGroup>
        <b-button :disabled="disabled" variant="success" type="submit"
          >ثبت</b-button
        >
      </BForm>
    </b-modal>
  </main>
</template>

<script>
import ExperimentsImpl from "@@/core/pages/experiment/Experiments/ExperimentsImpl.js";
export default {
  extends: ExperimentsImpl,
};
</script>
